import { render, staticRenderFns } from "./AssignTeamLeader.vue?vue&type=template&id=e2af5a9c&scoped=true"
import script from "./AssignTeamLeader.vue?vue&type=script&lang=js"
export * from "./AssignTeamLeader.vue?vue&type=script&lang=js"
import style0 from "./AssignTeamLeader.vue?vue&type=style&index=0&id=e2af5a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2af5a9c",
  null
  
)

export default component.exports